(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gender-toggle"] && !Shopify.designMode) return;
  try {
    (function () {
      function isAllowed(tag, gender) {
        if (!gender) return true;
        if (gender === 'man' && tag === 'woman') return false;
        if (gender === 'woman' && tag === 'men') return false;
        return true;
      }

      function unveilLazy(container) {
        if (!container || !window.lazySizes || !window.lazySizes.loader) return;

        container.querySelectorAll('img.lazyload, img.Image--lazyLoad').forEach(function (img) {
          window.lazySizes.loader.unveil(img);
        });
      }

      /** Stack gallery uses opacity:0 until Image--lazyLoaded — force-show after gender filter. */
      function revealVisibleImages(gallery) {
        gallery.querySelectorAll('.Product__SlideItem:not(.is-gender-hidden) img').forEach(function (img) {
          var dataSrc = img.getAttribute('data-src');
          if (dataSrc && (!img.getAttribute('src') || img.getAttribute('src') === '')) {
            img.setAttribute('src', dataSrc);
          }
          img.classList.add('lazyloaded', 'Image--lazyLoaded');
          img.classList.remove('lazyload');
        });
      }

      function filterPdpGallery(gender) {
        var galleries = document.querySelectorAll('.Product__Gallery[data-gender-gallery]');
        if (!galleries.length) return;

        galleries.forEach(function (gallery) {
          gallery.querySelectorAll('[data-gender-tag]').forEach(function (item) {
            item.classList.toggle('is-gender-hidden', !isAllowed(item.getAttribute('data-gender-tag'), gender));
          });

          var imageIndex = 0;
          gallery.querySelectorAll('.Product__SlideItem--image.is-gender-hidden').forEach(function (slide) {
            slide.removeAttribute('data-image-media-position');
          });
          gallery.querySelectorAll('.Product__SlideItem--image:not(.is-gender-hidden)').forEach(function (slide) {
            slide.setAttribute('data-image-media-position', String(imageIndex));
            imageIndex += 1;
          });

          var firstSlide = gallery.querySelector('.Product__SlideItem:not(.is-gender-hidden)');
          gallery.querySelectorAll('.Product__SlideItem.is-selected').forEach(function (slide) {
            slide.classList.remove('is-selected');
          });
          if (firstSlide) firstSlide.classList.add('is-selected');

          gallery.querySelectorAll('.Product__SlideshowNavImage.is-selected, .Product__SlideshowNavDot.is-selected').forEach(function (nav) {
            nav.classList.remove('is-selected');
          });

          if (firstSlide) {
            var firstId = firstSlide.getAttribute('data-media-id');
            gallery.querySelectorAll('.Product__SlideshowNavImage[data-media-id="' + firstId + '"], .Product__SlideshowNavImage[href="#Media' + firstId + '"]').forEach(function (thumb) {
              thumb.classList.add('is-selected');
            });
            var firstDot = gallery.querySelector('.Product__SlideshowNavDot[href="#Media' + firstId + '"]');
            if (firstDot) firstDot.classList.add('is-selected');
          }

          var mobileNav = gallery.querySelector('.Product__SlideshowMobileNav');
          if (mobileNav) {
            var visibleSlides = gallery.querySelectorAll('.Product__SlideItem:not(.is-gender-hidden)');
            mobileNav.hidden = visibleSlides.length <= 1;
          }

          // Do not touch Flickity cells here — reloadCells + cellSelector empties the gallery.
          // ProductSection rebuilds the carousel after this event (rescue → destroy → reinit).
          document.documentElement.dispatchEvent(new CustomEvent('gender:pdp-gallery-refresh', {
            detail: { gender: gender, gallery: gallery }
          }));

          requestAnimationFrame(function () {
            revealVisibleImages(gallery);
            if (firstSlide) unveilLazy(firstSlide);
            gallery.querySelectorAll('.Product__SlideItem:not(.is-gender-hidden)').forEach(function (slide) {
              unveilLazy(slide);
            });
          });
        });
      }

      document.documentElement.addEventListener('gender:changed', function (event) {
        filterPdpGallery(event.detail && event.detail.gender);
      });

      function syncFromSwitch() {
        var gender = window.GenderSwitch && typeof window.GenderSwitch.get === 'function'
          ? window.GenderSwitch.get()
          : document.documentElement.getAttribute('data-gender') || null;
        filterPdpGallery(gender);
        // ProductSection may bind its rebuild listener after this snippet runs
        window.setTimeout(function () {
          document.documentElement.dispatchEvent(new CustomEvent('gender:pdp-gallery-refresh', {
            detail: { gender: gender }
          }));
        }, 80);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncFromSwitch);
      } else {
        syncFromSwitch();
      }
    })();
  } catch(e) { console.error(e); }
})();

})();
